require('../../components');
require('../components/select-city');

/*
    Показываем/скрываем инфополосу
 */
eventClick('.top-warning-block, .content_block', function () {
    $('.content_block').slideToggle(300);
    $('.read-msg').toggleClass('flip');
});


/*
    Просмотр уведомлений
*/
eventClick('.notification .toggle', function () {
    $('.notification .notification-content').toggleClass('visible');
});

$(document).on('click', function(event) {
    if (!$(event.target).closest('.notification').length) {
        $('.notification .notification-content').removeClass('visible');
    }
});


if ($(".select").length) {
    $(".select").each(function () {
        let selElmnt = $(this).find("select")[0];
        let ll = selElmnt.length;
        let a = $('<div class="select-selected"></div>');
        a.html(selElmnt.options[selElmnt.selectedIndex].innerHTML);
        $(this).append(a);
        let b = $('<div class="select-items select-hide"></div>');
        for (let j = 1; j < ll; j++) {
            let c = $(`<div data-val='${selElmnt.options[j].value}'></div>`);
            c.html(selElmnt.options[j].innerHTML);
            c.on("click", function (e) {
                let s = $(this).parent().parent().find("select")[0];
                let sl = s.length;
                let h = $(this).parent().prev();
                for (let i = 0; i < sl; i++) {
                    if (s.options[i].innerHTML == this.innerHTML) {
                        s.selectedIndex = i;
                        h.html(this.innerHTML);
                        let y = $(this).parent().find(".same-as-selected");
                        let yl = y.length;
                        for (let k = 0; k < yl; k++) {
                            y[k].classList.remove("same-as-selected");
                        }
                        $(this).addClass("same-as-selected");
                        break;
                    }
                }
                c.parents("select").val("2");
                h.click();
            });
            b.append(c);
        }
        $(this).append(b);
        a.on("click", function (e) {
            e.stopPropagation();
            closeAllSelect(this);
            $(this).next().toggleClass("select-hide");
            $(this).toggleClass("select-arrow-active");
        });
    });

    function closeAllSelect(elmnt) {
        let x = $(".select-items");
        let y = $(".select-selected");
        let xl = x.length;
        let yl = y.length;
        let arrNo = [];
        for (let i = 0; i < yl; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i);
            } else {
                $(y[i]).removeClass("select-arrow-active");
            }
        }
        for (let i = 0; i < xl; i++) {
            if (arrNo.indexOf(i)) {
                $(x[i]).addClass("select-hide");
            }
        }
    }

    $(document).on("click", closeAllSelect);
}


$(".js_selectField").select2({
    dropdownParent: $(".selectField"),
});

$(".js_selectField").on("change", function () {
    let tab = $(this).val();

    $(".selectField").addClass("selected");
    $(".view").removeClass("active");
    $(`#${tab}`).addClass("active");
});

$('.js_selectField').on('select2:close', function (e) {
    $('.moreOptions').removeClass('list__selecting')
});

$('.js_selectField').on('select2:open', function (e) {
    if (!$('.moreOptions .view.active').length) {
        $('.moreOptions').addClass('list__selecting')
    }
});

$(".js_incoming").on("click", function () {
    $(this).parents(".field").toggleClass("opened");
});

let scrolledPosition = null

$('[data-open]').on('click', function () {
    let modalAttr = $(this).data('open')
    $(`[data-modal=${modalAttr}]`).addClass('opened')

    if ($(window).width() <= 576) {
        scrolledPosition = rememberScrolledPosition()
        openModalMobile();
        return scrolledPosition
    }
})

$('.moreProducts .tags .item').on('click', function () {
    console.log($(this).text())
    $('.moreProducts').addClass('selectedTagShowed')
    $('.moreProducts [data-breadcrumb]').text($(this).text())
    $('.breadcrumbs li').removeClass('active')
    $('.breadcrumbs').append(`<li class="active"><a>${$(this).text()}</a></li>`)

    $('.breadcrumbs').scrollLeft(1000)
})

$(".js_closeModal, .button-cancel").on("click", function () {
    if ($(window).width() <= 576) {
        if ($(this).parents('.moreProducts.selectedTagShowed').length) {
            $('.moreProducts').removeClass('selectedTagShowed')
            $('.moreProducts [data-breadcrumb]').text('Дополнительные товары')
            $('.breadcrumbs li:last-child').remove()
            $('.breadcrumbs li:last-child').addClass('active')
        } else {
            window.scrollTo(0, scrolledPosition)
            $('.breadcrumbs').removeClass('absolute')
            if ($('.breadcrumbs li.active').text() === $("[data-modal].opened").find('[data-breadcrumb]').data('breadcrumb')) {
                $('.breadcrumbs li:last-child').remove()
                $('.breadcrumbs li:last-child').addClass('active')
            }

            $('body').removeClass('overflow-hidden')
            $(".modal-wrapper").removeClass("opened");
        }
    } else {
        $('body').removeClass('overflow-hidden')
        $(".modal-wrapper").removeClass("opened");
    }
});

function openModalMobile() {
    let marginTop = $("header").height() + $(".breadcrumbs").height() + 60,
        newBreadcrumb = $("[data-modal].opened").find('[data-breadcrumb]').data('breadcrumb')
    window.scrollTo(0, 0);
    $(".modal-wrapper.opened .modal-block").css("margin-top", marginTop + 'px');
    $('.breadcrumbs').addClass('absolute')
    if (newBreadcrumb) {
        $('.breadcrumbs li').removeClass('active')
        $('.breadcrumbs').append(`<li class="active"><a>${newBreadcrumb}</a></li>`)
    }
    $('body').addClass('overflow-hidden')
}
function rememberScrolledPosition() {
    return window.pageYOffset || document.documentElement.scrollTop
}


$(document).ready(function () {
    if ($(".js_ticket_select").length) {
        $(".js_ticket_select").each(function () {
            let dropdownParent = $(this).find(".dropdown-container");
            $(this).find(".js_selectField").select2({
                dropdownParent: dropdownParent,
            });
        });
    }

    if ($(".profile_blank_grid_item_head .dots").length) {
        $(".profile_blank_grid_item_head .dots").each(function () {
            $(this).on('click', function () {
                $(this).siblings('.hidden_block').toggleClass('active');
            })
        });
    }

    if ($(".profile_blank_grid_item_head .hidden_block a").length) {
        $(".profile_blank_grid_item_head .hidden_block a").each(function () {
            $(this).on('click', function () {
                $(this).parents('.hidden_block').toggleClass('active')
            })
        });
    }

    if ($(".js_showDetails").length) {
        $(".js_showDetails").each(function () {
            $(this).on('click', function () {
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active')
                    $(this).children('span').text('+')
                } else {
                    $(this).addClass('active')
                    $(this).children('span').text('-')
                }
            })
        });
    }
});

import Swiper, { Pagination, Navigation } from "swiper";

if ($(".main-promo").length) {
    new Swiper(".swiper-promo", {
        modules: [Pagination, Navigation],
        loop: false,
        slidesPerView: 1,
        spaceBetween: 88,
        navigation: {
            disabledClass: "slider-nav__btn--disabled",
            nextEl: ".main-promo__wrapper .slider-nav__btn--next",
            prevEl: ".main-promo__wrapper .slider-nav__btn--prev",
        },
        pagination: {
            el: ".main-promo__wrapper .promo-slider__dots",
            type: "bullets",
            bulletClass: "nav-dots__btn",
            bulletActiveClass: "nav-dots__btn--active",
            bulletElement: "button",
            clickable: !0,
        },
    });
}

if ($(".swiper-reviews").length) {
    new Swiper(".swiper-reviews", {
        modules: [Pagination, Navigation],
        roundLengths: !0,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 30,
                centeredSlides: !0,
            },
            768: {
                slidesPerView: 1.5,
                spaceBetween: 30,
                centeredSlides: !0,
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 40,
                centeredSlides: !1,
            },
            1240: {
                slidesPerView: 2.132,
                spaceBetween: 102,
                centeredSlides: !1,
            },
        },
        navigation: {
            disabledClass: "slider-nav__btn--disabled",
            nextEl: ".swiper-reviews .slider-nav__btn--next",
            prevEl: ".swiper-reviews .slider-nav__btn--prev",
        },
    });
}

if ($(".cashback-slider").length) {
    new Swiper(".cashback-slider", {
        modules: [Pagination, Navigation],
        roundLengths: !0,
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: true,
        breakpoints: {
            // 320: {
            //     slidesPerView: 1,
            //     spaceBetween: 30,
            //     centeredSlides: !0,
            // },
        },
        navigation: {
            disabledClass: "cashback--disabled",
            nextEl: ".cashback-slider .cashback-next",
            prevEl: ".cashback-slider .cashback-prev",
        },
    });
}


$('.main-subscription__form').on('submit', function(event) {
    event.preventDefault();
    $('.main-subscription').fadeOut(500, function() {
        $('.main-promo-subscription').fadeIn(500);
    });
});